function dateToComparableNumber(date: string) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = +date.substring(6, 10);
  const monthNumber = +date.substring(0, 2);
  const dayNumber = +date.substring(3, 5);
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

function mediumDateToComparableNumber(date: string) {
  const dateAsString = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  if (
    dateAsString === undefined ||
    dateAsString === null ||
    dateAsString.length !== 10
  ) {
    return null;
  }

  const yearNumber = +dateAsString.substring(6, 10);
  const monthNumber = +dateAsString.substring(0, 2);
  const dayNumber = +dateAsString.substring(3, 5);
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

export function dateStringComparator(date1: string, date2: string) {
  const date1Number = dateToComparableNumber(date1);
  const date2Number = dateToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

export function mediumDateStringComparator(date1: string, date2: string) {
  const date1Number = mediumDateToComparableNumber(date1);
  const date2Number = mediumDateToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

export function dateFilterStringComparator(
  filterLocalDateAtMidnight: Date,
  cellValue: string,
) {
  const dateAsString = new Date(cellValue).toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  if (dateAsString == null) {
    return 0;
  }

  // In the example application, dates are stored as dd/mm/yyyy
  // We create a Date object for comparison against the filter date
  const dateParts = dateAsString.split('/');
  const day = Number(dateParts[1]);
  const month = Number(dateParts[0]) - 1;
  const year = Number(dateParts[2]);
  const cellDate = new Date(year, month, day);

  // Now that both parameters are Date objects, we can compare
  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
}

export function dateFilterStringRangeComparator(
  filterLocalDateAtMidnight: Date,
  cellValue: string,
) {
  const dateCellValue = cellValue.split(' - ');
  const dateCellStart = dateCellValue[0];
  const dateCellEnd = dateCellValue[1];

  const dateAsStringStart = new Date(dateCellStart).toLocaleDateString(
    'en-US',
    {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  );

  const dateAsStringEnd = new Date(dateCellEnd).toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  if (dateAsStringStart == null && dateAsStringEnd == null) {
    return 0;
  }

  // In the example application, dates are stored as dd/mm/yyyy
  // We create a Date object for comparison against the filter date
  const datePartsStart = dateAsStringStart.split('/');
  const dayStart = Number(datePartsStart[1]);
  const monthStart = Number(datePartsStart[0]) - 1;
  const yearStart = Number(datePartsStart[2]);
  const cellDateStart = new Date(yearStart, monthStart, dayStart);

  // In the example application, dates are stored as dd/mm/yyyy
  // We create a Date object for comparison against the filter date
  const datePartsEnd = dateAsStringEnd.split('/');
  const dayEnd = Number(datePartsEnd[1]);
  const monthEnd = Number(datePartsEnd[0]) - 1;
  const yearEnd = Number(datePartsEnd[2]);
  const cellDateEnd = new Date(yearEnd, monthEnd, dayEnd);

  // Now that both parameters are Date objects, we can compare
  if (
    cellDateStart < filterLocalDateAtMidnight &&
    cellDateEnd < filterLocalDateAtMidnight
  ) {
    return -1;
  } else if (
    cellDateStart > filterLocalDateAtMidnight &&
    cellDateEnd > filterLocalDateAtMidnight
  ) {
    return 1;
  }

  return 0;
}

export function ascendingNumbersComparator(a: string, b: string) {
  const valA = parseInt(a, 10);
  const valB = parseInt(b, 10);
  if (valA === valB) {
    return 0;
  }
  return valA > valB ? 1 : -1;
}
